export default {
  hint: {
    1: 'Plateforme sécurisée',
    2: 'Satisfait ou remboursé sous 14 jours',
    3: 'Suivi et conseils',
    4: 'développé par des experts'
  }
}
